import React from 'react'
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import monthlyPlanIcon from '../../assets/images/icons/monthly-calendar.svg';
import dailyPlanIcon from '../../assets/images/icons/Icon awesome-clock.svg';
import changeShiftIcon from '../../assets/images/icons/shuffle-solid.svg';
import notificationsIcon from '../../assets/images/icons/bell-solid.svg';
import { Container, StyledButton, StyledReactSVG, ButtonWrapper, Circle, CircleText, KorisnikWrapper } from './Dashboard.style';
import { useNotifications } from '../Notifications/hooks/notifications';
import { useState, useContext, useEffect } from 'react';
import { useAuthStateValue } from '../../context/AuthContext';
import { Spin } from 'antd';

const MainHeader = () => {

  const { t } = useTranslation();
  const { loggedUser, setLoggedUser } = useAuthStateValue();
  const [isNotificationsOnly, setIsNotificationsOnly] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const { fetchNotifications, loading, dataSource } = useNotifications();
  const notificationsNumber = dataSource?.length;

  useEffect(() => {
    const userId = loggedUser?.id;
    fetchNotifications(userId);
    const extendUser = loggedUser?.extendUser;
    if (extendUser?.workplace === "Korisnik" && extendUser?.organizationalUnitName === "Korisnik sistema") {
      setIsNotificationsOnly(true);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, [loggedUser]);

  let emptyNotificationsList = true;
  let showNotificationCircle = false;
  if (notificationsNumber > 0) {
    emptyNotificationsList = false;
    showNotificationCircle = true;
  }

  if (isLoading) {
    return (
      <Container>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
          <Spin size="large" />
        </div>
      </Container>
    );
  }

  return (
    <Container>
    <ButtonWrapper>
      {isNotificationsOnly ? (
        <KorisnikWrapper>
        <NavLink style={{textDecoration: 'none'}} to="/notifications">
        <StyledButton>
          <StyledReactSVG src={notificationsIcon}></StyledReactSVG>
          <span>{t('main.notifications')}</span>
          { showNotificationCircle && 
            <Circle>
              <CircleText>{notificationsNumber}</CircleText>
            </Circle> 
          }
        </StyledButton>
      </NavLink>
      </KorisnikWrapper>
      ) : (
        <>
          <NavLink style={{textDecoration: 'none'}} to='/monthlyPlan'>
            <StyledButton>
              <StyledReactSVG src={monthlyPlanIcon}></StyledReactSVG>
              <span>{t('main.monthlyPlan')}</span>
            </StyledButton>
          </NavLink>
          <NavLink style={{textDecoration: 'none'}} to='/dailyPlan'>
            <StyledButton>
              <StyledReactSVG src={dailyPlanIcon}></StyledReactSVG>
              <span>{t('main.dailyPlan')}</span>
            </StyledButton>
          </NavLink>
          <NavLink style={{textDecoration: 'none'}} to="/changeShift">
            <StyledButton>
              <StyledReactSVG src={changeShiftIcon}></StyledReactSVG>
              <span>{t('main.changeWorkShifts')}</span>
            </StyledButton>
          </NavLink>
          <NavLink style={{textDecoration: 'none'}} to="/notifications">
            <StyledButton>
              <StyledReactSVG src={notificationsIcon}></StyledReactSVG>
              <span>{t('main.notifications')}</span>
              { showNotificationCircle && 
                <Circle>
                  <CircleText>{notificationsNumber}</CircleText>
                </Circle> 
              }
            </StyledButton>
          </NavLink>
        </>
      )}
    </ButtonWrapper>
  </Container>
  )
}

export default MainHeader